// extracted by mini-css-extract-plugin
export var dividerLine = "_b8-3";
export var itemImage = "_b8-9";
export var lightDivider = "_b8-4";
export var modalContent = "_b8-5";
export var modalContentCompact = "_b8-6";
export var productCard = "_b8-a";
export var productImage = "_b8-b";
export var productImageCompact = "_b8-7";
export var productImagePlaceholder = "_b8-c";
export var productImagePlaceholderCompact = "_b8-8";
export var progressBarBackground = "_b8-1";
export var progressBarContainer = "_b8-0";
export var progressBarFill = "_b8-2";